module.exports = __webpack_public_path__ + "static/media/icon-agendaMedica-off.28e7f2e3.svg";